import * as ui  from '../utils/log';
const TradingblockApiEndpointUrl = 'https://staging.tradingblock.com/RestHub/';
//
import {MemberAccount, SubAccount} from '../domain/Accounts';
import {CancelOrderRequest, EditOrderRequest, PositionRequestType} from '../domain/DTO';
import {Order} from '../domain/Order';
import {Position} from '../domain/Position';
import {ErrorCodeMap} from '../domain/TbMaps';

import {
  AssetType, CharAssetType, Options, OrderAction,
  OrderDuration,
  PositionEffect, Quote,
} from '../domain/types';
import {clearCookie, getCookie, setCookie} from '../utils/cookies';
import {offsetToMilliseconds} from '../utils/formatters';
import AuthService from './AuthService';
import NoteService from './NoteService';
import EliteOrdersService from './EliteOrders';
import {EventBus, Messages} from './EventBus';
import QuoteService from './Quotes';
import { fixUtcFormat } from '@/utils/vue_utils';

function trimLeft0(v: string): string {
  let start = -1;

  while (v.charCodeAt(++start) === 48) { }

  return v.slice(start, v.length);
}

export interface Filter {
  WorkingOrdersOnly?: boolean;
  pageIndex: number;
  pageSize?: number;
  ExcludeDurationId?: OrderDuration;
  durationId?: OrderDuration;
  SecurityTypeId?: number;
  orderId?: number;
  orderStatusId?: number;
  dateFrom?: string;
  dateTo?: string;

  symbol?: string;
  subaccountId?: number;
  accountId?: number;
  includeOrderEvents?: boolean;
}

export interface OrderResponse {
  Items: Order[];
  TotalNumOfAvailableItems: number;

}

export function padStart(str: string, targetLength: number, padString: string) {
  targetLength = Math.floor(targetLength) || 0;
  if (targetLength < str.length) { return String(str); }

  padString = padString ? String(padString) : ' ';

  let pad = '';
  const len: number = targetLength - str.length;
  let i = 0;
  while (pad.length < len) {
    if (!padString[i]) {
      i = 0;
    }
    pad += padString[i];
    i++;
  }

  return pad + String(str).slice(0);
}

// as harness has auth placed inside
class TradingBlockRemote {

  private static authService: AuthService = new AuthService();
  private static noteService: NoteService = new NoteService();


  private static AccountId: number = -1;
  private static SubaccountId: number = 1;
  public method: string = 'post';
  // public url = TradingblockApiEndpointUrl;
  public options: {
    onComplete: ((obj: any) => void),
    onFailure: ((obj: any) => void),
  };

  public static get ActiveAccountId()  {
    return TradingBlockRemote.AccountId;
  }
  public static get accountChoosed(): boolean {
    if (TradingBlockRemote.AccountId === -1) { console.error('auth check -1'); }
    return !isNaN(TradingBlockRemote.AccountId) && !isNaN(TradingBlockRemote.SubaccountId) ;
  }

  public static login(tradeBlockName: string, tradeBlockPassword: string, live: boolean): Promise<any> {
    if (process.env.VUE_APP_DEBUG_LOG) { console.log('auth:login-start'); }
    return new Promise((resolve, reject) => {
      TradingBlockRemote.authService.login(tradeBlockName, tradeBlockPassword, live, resolve, reject);
    });
  }



  public static logout() {
    if (process.env.VUE_APP_DEBUG_LOG) { console.log('auth:logout-start'); }
    return new Promise((resolve, reject) => {
      // TradingBlockRemote.authService.logout(resolve, reject);
    }).then(() => {
      EventBus.$emit(Messages.tradeOrderWindowClose);
    });
  }

  public static getToken(): string | null {

    return  TradingBlockRemote.authService.getTOKEN();
  }

  public static get authenticated(): boolean {
    return TradingBlockRemote.authService.authenticated();
  }

  public static needAgreement() {
    return TradingBlockRemote.authService.checkAgreement();
  }

  public static setAgreement() {
    return TradingBlockRemote.authService.setAgreement();
  }

  public static async  GetAccounts(): Promise<MemberAccount[]> {

    return new Promise((resolve: (o: MemberAccount[]) => void, reject: any) => {
      const tb = new TradingBlockRemote({onComplete: (res: any) => resolve(res), onFailure: (e: any) => reject(e)});
      tb.requestViaUrlParam('Accounts/GetAccounts', '', {omitAccount: true, omitSubAcc: true});
    });
  }

  public static GetSubAccounts(accountId: number): Promise<SubAccount[]> {
    return new Promise((resolve: (o: SubAccount[]) => void, reject: any) => {
      const tb = new TradingBlockRemote({onComplete: (res: any) => resolve(res), onFailure: (e: any) => reject(e)});
      tb.requestViaUrlParam('Accounts/GetSubAccounts',
        '?accountId=' + accountId, {omitAccount: true, omitSubAcc: true});
    });
  }
  public static AccountNumber: string;
  public static SetSubAccount(subAccount: SubAccount) {
    TradingBlockRemote.AccountId = subAccount.AccountId;
    TradingBlockRemote.SubaccountId = subAccount.Id;
    TradingBlockRemote.AccountNumber = subAccount.Number;
    EventBus.$emit(Messages.AccountWithSubChange as string, subAccount);


    clearCookie('LastAccountId');
    clearCookie('LastSubAccountId');
    clearCookie('LastAccNumber');
    setCookie('LastAccountId', subAccount.AccountId.toString());
    setCookie('LastSubAccountId', subAccount.Id.toString());
    setCookie('LastAccNumber', subAccount.Number.toString());

  }

  public static GetLastSubAccount() {
    AuthService.loadPreviousLive();
    const accId = parseInt(getCookie('LastAccountId'), 10);
    const subAccId = parseInt(getCookie('LastSubAccountId'), 10);

    TradingBlockRemote.AccountId = accId;
    TradingBlockRemote.SubaccountId = subAccId;
    TradingBlockRemote.AccountNumber = getCookie('LastAccNumber');
    return {AccountId: TradingBlockRemote.AccountId, Id: TradingBlockRemote.SubaccountId};
  }

  public static getQuotesForPositions(id: number, positions: string[]): Promise<any> {
    if (positions.length === 0) {
      return Promise.resolve([]);
    }
    const symbols = positions;
    // const symbols = positions.map(e => {
    //     if (e.AssetType !== CharAssetType.Option) {
    //         return e.Symbol;
    //     }
    //     else {
    //         const a = e.Symbol.split(' ');
    //         const d = a[1].substr(0, 6);
    //         const t = a[1][6];
    //         const p = padStart(a[1].substr(7), 8, '0');
    //         return a[0] + d + t + p;
    //     }
    //
    // });
    // if (symbols.length === 0) {
    //     return [];
    // }
    try {
      return new Promise((resolve: (o: Quote[]) => void, reject: () => void) => {
        const apiQuotes =
          QuoteService.loadFromTradingBlock(id, symbols).then((o: any) => {resolve(o); }).catch ((e: any) => {reject(); });
      });

    } catch (exc) {
      throw new Error('error mapping quotes');
    }
    // const apiQuotes = await QuoteService.loadBySymbolList(symbols);
    /* try{
         const quotes = apiQuotes.map((q:Quote) => {
             const formatted = q;
             formatted.Symbol = TradingBlockRemote.TradespoonToTradeblockSymbol(q.AssetClass, q.Symbol);
             return formatted;
         });
         return quotes;
     } catch (exc){
         throw new Error('error mapping quotes');
     }*/
  }

  public static TradeblockToTradespoonSymbol(assetType: AssetType, symbol: string): string {
    if (assetType === 2) {
      const a = symbol.split(' ');
      const sym = a[0];
      const dateSide = a[1]!.substr(0, 7);
      const price = padStart(a[1]!.substr(7), 8, '0');

      return sym! + dateSide + price;
    } else {
      return symbol;
    }
  }

  public static TradespoonToTradeblockSymbol(assetType: AssetType, symbol: string): string {
    if (assetType === 2) {
      const a1 = symbol.substr(0, symbol.length - 8);
      const sym = a1.match(/\D+/i);
      const dc = a1.substr(sym![0].length);
      const a2 = trimLeft0(symbol.substr(symbol.length - 8, symbol.length - 1));

      return sym![0] + ' ' + dc + a2;
    } else {
      return symbol;
    }
  }

  public static AddMandatoryFields(o: any): any {
    return {...o, accountId: TradingBlockRemote.AccountId, subaccountId: TradingBlockRemote.SubaccountId};
  }

  private static toQuery(o: any) {
    const str: string[] = [];
    const obj = TradingBlockRemote.AddMandatoryFields(o);

    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
      }
    }
    const s = str.length > 0 ? '?' + str.join('&') : '';
    return s;
  }

  constructor(options: any) {
    this.options = options;

  }

  public request(ep: string, o: any, options?: any): XMLHttpRequest {
    const xhr = new XMLHttpRequest() as any;

    const obj = TradingBlockRemote.AddMandatoryFields(o);

    if (options && options.method) {
      xhr.open(options.method, AuthService.getUrl() + ep, true);
    } else {
      xhr.open('post', AuthService.getUrl() + ep, true);
    }
    const token = TradingBlockRemote.authService.getTOKEN();
    if (process.env.VUE_APP_DEBUG_LOG && !token) {
      console.error('No token ' + TradingBlockRemote.authService.getTOKEN());
    }
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Authorization', token);
    // obj =  Object.assign(obj, controllers.getLoginCtrl().getAccountParams());

    xhr.send(JSON.stringify(obj));
    xhr.onFailure = this.onFailure.bind(this);
    xhr.onComplete = this.onComplete.bind(this);
    xhr.onreadystatechange = function() {
      if (this.readyState !== 4) { return; }

      if (this.status !== 200) {
        if (process.env.VUE_APP_DEBUG_LOG) { console.warn('bad status:' + this.status); }
        return xhr.onFailure(-this.status);
      }

      return xhr.onComplete(this.response);
    };
    return xhr;
  }

  public requestViaUrlParam(ep: string, params: string, options?: any): XMLHttpRequest {
    const xhr = new XMLHttpRequest() as any;

    if (options && params.length > 0) {
      if (!options.omitSubAcc && TradingBlockRemote.SubaccountId > 0) {
        params = `${params}&subaccountId=${TradingBlockRemote.SubaccountId}`;
      }
      if (!options.omitAccount && TradingBlockRemote.AccountId > 0) {
        params = `${params}&accountId=${TradingBlockRemote.AccountId}`;
      }
    } else if (options) {
      if (!options.omitSubAcc && TradingBlockRemote.SubaccountId > 0) {
        params += `?subaccountId=${TradingBlockRemote.SubaccountId}`;
      }
      if (!options.omitAccount) {
        params += params.length > 0 ? '&' : '?' + `accountId=${TradingBlockRemote.AccountId}`;
      }
    }

    if (options && options.method) {
      xhr.open(options.method, '/api/portfolio/' + ep, true);
    } else {
      xhr.open('get', '/api/portfolio/' + ep + params);
    }
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Authorization', TradingBlockRemote.authService.getTOKEN());

    if (process.env.VUE_APP_DEBUG_LOG && !params) { console.log('request:empty params'); }
    xhr.send();
    xhr.onFailure = this.onFailure.bind(this);
    xhr.onComplete = this.onComplete.bind(this);
    xhr.onreadystatechange = function() {
      if (this.readyState !== 4) { return; }

      if (this.status === 522) {
        ui.error.log('Please relogin, timeout for tradingblock session!');
        AuthService.afterLogout();
        return xhr.onFailure(-this.status);
      }
      if (this.status !== 200) {
        if (process.env.VUE_APP_DEBUG_LOG) { console.warn('request:bad status' + this.status); }
        ui.error.log('Bad status from trading block');

        return xhr.onFailure(-this.status);
      }

      return xhr.onComplete(this.response);
    };
    return xhr;
  }

  public GetOrders(filter: Filter): XMLHttpRequest {
    const params = TradingBlockRemote.toQuery(filter);

    return this.requestViaUrlParam('Orders/GetOrders', params);
    // return this.request(AuthService.getUrl() + "Orders/GetOrders", JSON.stringify(obj));
  }

  public PlaceOrder(order: Order): XMLHttpRequest {
    return this.request('Orders/PlaceOrder', order);
  }

  public EditOrder(order: EditOrderRequest): XMLHttpRequest {
    // if (order.Stop === null) { delete order.Stop; }
    // if (order.Price === null) { delete order.Price; }
    return this.request('Orders/ChangeOrder', order);
  }

  public CancelOrder(order: CancelOrderRequest): XMLHttpRequest {
    return this.request('Orders/CancelOrder', order);
  }

  public GetPositions(id: number, symbol?: string): XMLHttpRequest {
    const params = TradingBlockRemote.toQuery({RequestType: PositionRequestType.OpenPositions, UserId: 0, Symbols: null});
    return this.requestViaUrlParam(id + '/GetPositions', params); // , symbol? "?symbol="+ symbol:""
  }

  public GetQuotes(id: number, quotes: string[]) {

    return this.requestViaUrlParam(id + '/GetQuotes', '?RequestFundamental=true&symbols=' + quotes.join(','));
  }

  public GetBalance(): XMLHttpRequest {
    const params = TradingBlockRemote.toQuery({});
    return this.requestViaUrlParam('Balances/GetBalances', params);
  }

  public GetFunds(): XMLHttpRequest {
    return this.request('Balances/GetAvailableFunds', {});
  }

  public GetOptionChainExpiration(underlying: string) {
    if (!underlying || typeof underlying !== 'string' || underlying.length === 0) { throw new Error('No underlying!' + underlying); }
    return this.requestViaUrlParam('Chains/GetExpirations', '?underlyingsymbol=' + underlying);
  }

  public GetOptionChainStrikes(underlying: string, expiration: Date, offset: string) {
    if (!underlying || typeof underlying !== 'string' || underlying.length === 0) { throw new Error('No underlying!' + underlying); }
    const d = new Date(expiration);
    // d.setTime(d.getTime()+offsetToMilliseconds(offset));
    const date = this.formatDateForQuery(d);

    return this.requestViaUrlParam('Chains/GetStrikes', '?underlyingsymbol=' + underlying + '&expiration=' + date);
  }

  public GetOptionChain(underlying: string, expiration: Date) {
    if (!underlying || typeof underlying !== 'string' || underlying.length === 0) { throw new Error('No underlying!' + underlying); }
    const date = this.formatDateForQuery(expiration);

    return this.requestViaUrlParam('Chains/GetChains', '?underlyingsymbol=' + underlying + '&expiration=' + date);
  }

  public formatDateForQuery(expiration: Date) {
    if (!expiration  || isNaN(expiration.valueOf())) { throw new Error('No expiration!' + expiration); }

    const month = expiration.getMonth() + 1;
    const day = expiration.getDate();
    const year = expiration.getFullYear();
    return year + '-' + padStart(month.toString(), 2, '0') + '-' + padStart(day.toString(), 2, '0');
  }

  public onComplete(response: string) {
    let resp;

    function tryParseJSON(jsonString: string) {
      try {
        const o = JSON.parse(jsonString);
        return o;
      } catch (e) {
        if (process.env.VUE_APP_DEBUG_LOG) { console.error('catched bad json'); }
      }

      return false;
    }
    if (response === '' || !(resp = tryParseJSON(response)) || resp.ErrorCode > 0 || resp.ResponseCode > 0) {
      if (resp && (resp.ResponseCode > 0)) {
        const code = ErrorCodeMap[resp.ResponseCode] ? ErrorCodeMap[resp.ResponseCode] : resp.ResponseCode;
        ui.error.log(code + (resp.Payload && resp.Payload.Message ? ': ' + resp.Payload.Message : ''));
        if (resp.ResponseCode === 200)
          AuthService.afterLogout();
        if (process.env.VUE_APP_DEBUG_LOG) { console.error('response from TB:' + resp.ResponseCode); }
        this.options.onFailure(resp.ResponseCode);
      }
      if (resp.ResponseCode === 200 || resp.ErrorCode === 200) {

        AuthService.afterLogout();
      }
      EventBus.$emit(Messages.TradingBlockAjaxError);

      return;
    }
    const parsed = JSON.parse(response);

    if (parsed.Payload) {
      this.options.onComplete(parsed.Payload);
    } else {
      this.options.onComplete(parsed);
    }

  }

  public onFailure(status: string) {

    this.options.onFailure(JSON.parse(status));
  }

  // notes api
  public static DeleteNote(payload: {OrderId: number}) {
    return TradingBlockRemote.authenticated && TradingBlockRemote.noteService.DeleteNote(payload);
  }
  public static EditNote(payload: {OrderId: number, Description: string }) {
    return TradingBlockRemote.authenticated && TradingBlockRemote.noteService.EditNote(payload);
  }
  public static LoadNotes(payload: number[]) {
    return TradingBlockRemote.authenticated && TradingBlockRemote.noteService.LoadNotes({ids: payload});
  }

}

let _RefClientId = 1;
export const GetRefClientId = () => _RefClientId++;

export async function GetQuotesForOrders(response: OrderResponse) {
  const syms = extractLegSymbols(response);

  let quotes: any[] = [];
  if (syms.length > 0) {
    quotes = await TradingBlockRemote.getQuotesForPositions(0, syms);
    if (!quotes || quotes.length === 0) {console.warn('no quotes found for list of positions of ' + syms.length); }
  }
  return quotes;
}

export async function GetQuotesForEliteOrders(portfolioID: number, response: OrderResponse) {
  const syms = extractLegSymbols(response);

  let quotes: any[] = [];
  if (syms.length > 0) {
    quotes = await EliteOrdersService.loadQuotes(portfolioID, syms);
    if (!quotes) {
      quotes = [];
      console.warn('no quotes found for list of positions of ' + syms.length);
    }
  }
  return quotes;
}

function extractLegSymbols(response: OrderResponse) {
  return response.Items!.reduce((acc: string[], sym: Order) => {
    acc.push(sym.Legs[0].Symbol);
    if (sym.Legs[1]) {
      acc.push(sym.Legs[1].Symbol);
    }
    return acc;
//              if (sym.Legs.length>1)
//                  acc.push(sym.Legs[1].Symbol);
  }, []);
}

// we are not support now ratios 1/2 and more than 2quotes
function addQuotesToSpreadOrder(o: Order, quotes: Quote[]) {
  const ratio0 = (o.Legs[0]!.SpreadRatio!) / (o.Legs[0]!.SpreadRatio! + o.Legs[1]!.SpreadRatio!);
  const ratio1 = (o.Legs[1]!.SpreadRatio!) / (o.Legs[0]!.SpreadRatio! + o.Legs[1]!.SpreadRatio!);

  const quote0 = quotes.find((q: Quote) => {
    return q.Symbol === o.Legs[0].Symbol;
  });
  const quote1 = quotes.find((q: Quote) => {
    return q.Symbol === o.Legs[1].Symbol;
  });

  if (!quote0 || !quote1) {
    return {
      ...o, Date: new Date(fixUtcFormat(o.Date)), editing: false,
      Qty0: o.Quantity * ratio0,
      Qty1: o.Quantity * ratio1,

    } as any;
  } else {

    let LongBid = null, ShortBid = null, LongAsk = null, ShortAsk = null;
    if (o.Legs[0].Action === OrderAction.Buy && o.Legs[1].Action === OrderAction.Sell) {
      LongBid = quote0.BidPrice;
      ShortBid = quote1.BidPrice;
      LongAsk = quote0.AskPrice;
      ShortAsk = quote1.AskPrice;

    } else if (o.Legs[0].Action === OrderAction.Sell && o.Legs[1].Action === OrderAction.Buy) {
      LongBid = quote1.BidPrice;
      ShortBid = quote0.BidPrice;
      LongAsk = quote1.AskPrice;
      ShortAsk = quote0.AskPrice;
    }

    // ignore others conditions??

    const NaturalBid = LongBid! - ShortAsk!;
    const NaturalAsk = LongAsk! - ShortBid!;
    return {
      ...o, Date: new Date(fixUtcFormat(o.Date)), editing: false,
      Qty0: o.Quantity * ratio0,
      Qty1: o.Quantity * ratio1,

      BidPrice: NaturalBid,
      AskPrice: NaturalAsk,
    };
  }
}
function addQuoteToSingleOrder(o: Order, quotes: Quote[]) {
  const quote0 = quotes.find((q: Quote) =>{
    return q.Symbol === o.Legs[0].Symbol;
  });

  if (!quote0) {
    return {
      ...o, Date: new Date(fixUtcFormat(o.Date)), editing: false,
      Qty0: o.Quantity,
    } as any;
  } else {
    return {
      ...o, Date: new Date(fixUtcFormat(o.Date)), editing: false,
      Qty0: o.Quantity,
      BidPrice: quote0.BidPrice,
      AskPrice: quote0.AskPrice,
    };
  }

}
export function addQuotesToOrders(response: OrderResponse, quotes: any[]) {

  return response.Items!.map((o: any) => {
    if (o.Legs!.length === 2) {
      return addQuotesToSpreadOrder(o, quotes);
    } else {
      return addQuoteToSingleOrder(o, quotes);
    }

  });
}



export default TradingBlockRemote;
